import React from 'react'
import PropTypes from 'prop-types'
import Label from './Label'
import useInput from '../../hooks/useInput'

export default function CheckboxInput ({
  name, multiple, label, value, subobj, toggleAble
}) {

  const { getValue, setValue, addValue, removeValue, contains } = useInput()

  const handleOnChange = function () {
    let isCurrentlyChecked = contains(name, value, subobj)

    if (multiple) {
      if (isCurrentlyChecked) {
        removeValue(name, value, subobj)
      } else {
        addValue(name, value, subobj)
      }
    } else {
      if (isCurrentlyChecked && toggleAble) {
        setValue(name, null, subobj)
      } else {
        setValue(name, value, subobj)
      }
    }
  }

  const isChecked = contains(name, value, subobj)

  return (
    <div className={'checkbox'}>
      <Label>
        <input
          type={'checkbox'}
          checked={isChecked}
          onChange={handleOnChange}
        />
        <span dangerouslySetInnerHTML={{ __html: label }} />
      </Label>
    </div>
  )
}

CheckboxInput.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func
}